import type { SharedStorage } from "@/env";
import { isBrowser } from "@/utils/platform";

export class UniversalStorage {
  get<K extends keyof SharedStorage>(key: K) {
    if (isBrowser()) return window.__IAISharedStorage[key];

    return global._contextStorage?.getStore()?.locals.sharedStorage[key];
  }

  getAll() {
    return isBrowser()
      ? { ...window.__IAISharedStorage }
      : { ...global._contextStorage?.getStore()?.locals.sharedStorage };
  }

  set<K extends keyof SharedStorage>(key: K, value: SharedStorage[K]) {
    if (isBrowser()) {
      window.__IAISharedStorage[key] = value;
      return;
    }

    const context = global._contextStorage?.getStore();
    if (!context) return;
    if (!context.locals.sharedStorage) {
      context.locals.sharedStorage = {};
    }
    context.locals.sharedStorage[key] = value;
  }
}
export const universalStorage = new UniversalStorage();
